<div
    class="router-transitions"
    data-testid="t-oc-layout-blank-div-1752672977568-1"
>
    <router-outlet></router-outlet>
</div>
